import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule,Routes} from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { GlobalService } from './global.service';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { AuthInterceptor } from './app.interceptor';
import { RulesComponent } from './rules/rules.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UnosIzmjenaDomComponent } from './unos-izmjena-prijava-dom/unos-izmjena-dom.component';
import { UnosStatusComponent } from './unos-status/unos-status.component';
import { HomeKreditiComponent } from './home-krediti/home-krediti.component';
import { HomeStipComponent } from './home-stip/home-stip.component';
import { UnosIzmjenaKreditComponent } from './unos-izmjena-kredit/unos-izmjena-kredit.component';
import { UnosStatusKreditComponent } from './unos-status-kredit/unos-status-kredit.component';
import { UnosIzmjenaStipComponent } from './unos-izmjena-stip/unos-izmjena-stip.component';
import { FilterPrezimePipe } from './filter.pipe';
import { FilterImePipe } from './filter.pipe';
import { FilterDatumPipe } from './filter.pipe';
import { FilterBrzh } from './filter.pipe';
import { FilterKategorijaPipe } from './filter.pipe';
import { UnosStatusStipComponent } from './unos-status-stip/unos-status-stip.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    FooterComponent,
    LoaderComponent,
    RulesComponent, 
    UnosIzmjenaDomComponent, 
    UnosStatusComponent, 
    HomeKreditiComponent, 
    HomeStipComponent, 
    UnosIzmjenaKreditComponent, 
    UnosStatusKreditComponent, 
    UnosIzmjenaStipComponent, 
    FilterPrezimePipe, 
    FilterImePipe, 
    FilterDatumPipe, 
    FilterBrzh, 
    FilterKategorijaPipe, 
    UnosStatusStipComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule, 
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule],
  providers: [{provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor,multi: true }, GlobalService],
  bootstrap: [AppComponent]
})
export class AppModule { }
